export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  `http://${window.location.hostname}:4000`;

export const GRAPHQL_BACKEND_URL =
  process.env.REACT_APP_GRAPHQL_BACKEND_URL ||
  `http://${window.location.hostname}:4002`;
